module.exports = claims;